import {
    ACCOUNTS_EXPORT_LOGS_REQUEST,
    ACCOUNTS_EXPORT_LOGS_RESULT,
    ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST,
    ACCOUNTS_EXPORT_SEARCH_USERS_RESULT,
} from 'Redux/actionTypes';

export const accountsExportLogsRequest = (data) => ({
    type: ACCOUNTS_EXPORT_LOGS_REQUEST,
    payload: data
})

export const accountsExportLogsResult = (result) => ({
    type: ACCOUNTS_EXPORT_LOGS_RESULT,
    payload: result
})

export const accountsExportSearchUsersRequest = (data) => ({
    type: ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST,
    payload: data
})

export const accountsExportSearchUsersResult = (result) => ({
    type: ACCOUNTS_EXPORT_SEARCH_USERS_RESULT,
    payload: result
})